/* eslint-disable no-console */
import {
  apiClient,
  handleResponse,
} from './axios';

async function getCompany(id) {
  try {
    const response = await apiClient.get(`/company/${id}`);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}

async function getCompanyByStudent(userId) {
  try {
    const response = await apiClient.get(`/company/student/${userId}`);
    const company = await handleResponse(response);
    return company;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}

async function getCompanyDataById(companyId) {
  try {
    const response = await apiClient.get(`/companyData/${companyId}`);
    const user = await handleResponse(response);
    return user;
  } catch (error) {
    const res = await Promise.reject(error.response.data);
    return res;
  }
}
async function getExports() {
  const url = '/company/export';
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}
async function getExportsByCompany(id) {
  const url = `/company/export/${id}`;
  try {
    const response = await apiClient.get(url);
    const data = await handleResponse(response);
    return data;
  } catch (error) {
    return error.response;
  }
}

const companyServices = {
  getCompany,
  getCompanyByStudent,
  getCompanyDataById,
  getExports,
  getExportsByCompany,
};

export default companyServices;
